// src/icons/ArrowCircleTier2.tsx
import { jsx, jsxs } from "@emotion/react/jsx-runtime";
function ArrowCircleTier2() {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width: "100%",
      viewBox: "0 0 28 32",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx("circle", { cx: "14", cy: "14.9639", r: "14", fill: "white" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M19.7144 18.998L19.4944 10.298L10.7944 10.098L10.8144 11.998L16.6144 11.958L8.73438 19.838L9.97438 21.078L17.8344 13.218L17.7944 18.978L19.7144 18.998Z",
            fill: "#8B38DE"
          }
        )
      ]
    }
  );
}

export {
  ArrowCircleTier2
};
